export class ReorderInspectionTemplateError extends Error {
  constructor(message: string = 'Failed to reorder inspection template') {
    super(message);
    this.name = 'ReorderInspectionTemplateError';
  }
}
